import { useContext } from 'react';

import { config } from '../../config';
import { UserContext } from '../../contexts/UserContext';
import { getProvider } from '../../services/svpProvider';

import { Menu } from './Menu/Menu';
import { SideMenu } from './SideMenu/SideMenu';
import { ProviderSelect } from './ProviderSelect/ProviderSelect';

import type { FC } from 'react';

import styles from './Header.module.scss';

const Logo: FC<{ provider: string }> = ({ provider }) => {
  let logoUrl;
  switch (provider) {
    case 'vgtv':
      logoUrl = '/images/vgtv-logo.svg';
      break;
    case 'ab':
      logoUrl = '/images/ab-logo.svg';
      break;
    case 'brandstudio':
      logoUrl = '/images/bs-logo.svg';
      break;
    default:
      logoUrl = '/images/stream-logo.svg';
  }

  return (
    <div className={styles.Logo}>
      <img src={logoUrl} alt={provider} />
      {config.env !== 'production' && (
        <span className={styles.EnvLabel}>{config.env}</span>
      )}
    </div>
  );
};

const Header: FC = () => {
  const { user } = useContext(UserContext);

  return (
    <div className={styles.Header}>
      <div className={styles.MenuWrapper}>
        {user && user.role === 'admin' ? (
          <ProviderSelect>
            <Logo provider={getProvider()} />
          </ProviderSelect>
        ) : (
          <Logo provider={getProvider()} />
        )}
        <Menu />
      </div>
      <SideMenu />
    </div>
  );
};

export { Header };
